// @flow
import React from 'react';
import { withRouter } from 'react-router';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import mapProps from 'recompose/mapProps';
import compose from 'recompose/compose';
import both from 'ramda/es/both';
import any from 'ramda/es/any';
import path from 'ramda/es/path';
import propEq from 'ramda/es/propEq';
import pipe from 'ramda/es/pipe';
import assoc from 'ramda/es/assoc';
import omit from 'ramda/es/omit';

import type { TariffType } from 'app/components/Tariff/Tariff';
import { TARIFF_MONTHLY } from 'app/common/constants/tariffs';
import { router } from 'app/selectors/router';

import SubTariff from './SubTariff';
import styles from './InformsPacks.scss';


const isSmsSubscribeActive = path([
  'month_daily_params',
  'sms_subscribe_enabled',
]);

const isMonthly = propEq('kind', TARIFF_MONTHLY);

const enhance = compose(
  branch(
    ({ inside }) => !any(both(isMonthly, isSmsSubscribeActive), inside),
    renderNothing
  ),
  withRouter,
  mapProps(pipe(
    props => assoc('studentId', parseInt(router.getParam('id', props), 10), props),
    omit(['params', 'location', 'router', 'routes'])
  ))
);

type Props = {
  inside: Array<TariffType>,
  footnotes: Object,
  studentId: number,
  overrideTitle?: string,
  locked?: boolean,
}

const Options = ({
  inside,
  footnotes,
  studentId,
  overrideTitle,
  locked,
}: Props) => (
  <div>
    <div className={styles.line} />
    {/* <div className={styles.optionsName}>Опции:</div> */}
    <div className={styles.options}>
      {inside.map(tariff =>
        <SubTariff
          key={tariff.id}
          title={overrideTitle || tariff.title}
          tariff={tariff}
          studentId={studentId}
          footnotes={footnotes}
          locked={locked}
        />)}
    </div>
  </div>
);

export default enhance(Options);
